import React from 'react'

const generateBackgroundColor = (id: number): string => {
  const hue = id * 137.508 % 360
  return `hsl(${hue}, 65%, 80%)`
}

const getInitial = (name: string): string => {
  if (!name) return '?'
  return name.charAt(0).toUpperCase()
}

interface UserAvatarProps {
  id: number | string
  name: string
  size?: number
  unreadCount?: number
  className?: string
}

const UserAvatar = ({ id, name, size = 50, unreadCount = 0, className = '' }: UserAvatarProps) => {
  const numericId = typeof id === 'string' ? parseInt(id, 10) || Math.random() * 1000 : id
  const backgroundColor = generateBackgroundColor(numericId)

  const avatarDynamicStyle = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${Math.floor(size / 2.3)}px`,
    backgroundColor
  }

  const badgeSize = Math.max(16, Math.floor(size / 2.8))
  const badgeFontSize = Math.max(9, Math.floor(size / 4.5))
  const badgeOffset = Math.floor(size / 10)

  return (
    <div
      className={`tw-relative tw-flex-shrink-0 ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <div
        className='tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-slate-700 tw-font-semibold tw-overflow-hidden tw-select-none'
        style={avatarDynamicStyle}
        aria-label={`Awatar dla ${name}`}
      >
        {getInitial(name)}
      </div>
      {unreadCount > 0 && (
        <span
          className='tw-absolute tw-bg-[#ff5e14] tw-text-white tw-font-bold tw-rounded-full tw-flex tw-items-center tw-justify-center tw-pointer-events-none tw-border-2 tw-border-white dark:tw-border-slate-800'
          style={{
            width: `${badgeSize}px`,
            height: `${badgeSize}px`,
            fontSize: `${badgeFontSize}px`,
            lineHeight: `${badgeSize}px`,
            top: `-${badgeOffset / 2}px`,
            right: `-${badgeOffset / 2}px`
          }}
          title={`${unreadCount} nieprzeczytanych wiadomości`}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  )
}

export default UserAvatar
